import React from 'react';
import { Link } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { b2cPolicies, protectedResources } from 'services/b2cService';
import storeService from 'services/storeService';
import PropTypes from 'prop-types';

const ChangeEmail = ({ children, className, cphValue, onBlur, tabIndex }) => {
  const { instance } = useMsal();

  const handleChangeEmail = () => {
    // Clear permissions before redirecting to B2C
    storeService.session.remove.permissions();

    instance.loginRedirect({
      authority: b2cPolicies.authorities.changeEmail.authority,
      scopes: [...protectedResources.bff.scopes],
      extraQueryParameters: {
        c: cphValue
      }
    });
  };

  if (!cphValue) {
    return null;
  }

  return (
    <Link
      aria-label="Change Email"
      className={className}
      onBlur={onBlur}
      onClick={handleChangeEmail}
      role="button"
      tabIndex={tabIndex}
      to="#"
    >
      {children}
    </Link>
  );
};

ChangeEmail.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  cphValue: PropTypes.string,
  onBlur: PropTypes.func,
  tabIndex: PropTypes.number
};

ChangeEmail.defaultProps = {
  cphValue: '',
  tabIndex: 0
};

export default ChangeEmail;
